import { useTheme } from '../../../hooks/useTheme';

const WA_URL = 'https://wa.me/18495388899?text=Hola%20InnoFlex!%20Le%C3%AD%20su%20blog%20y%20quiero%20saber%20m%C3%A1s%20sobre%20la%20facturaci%C3%B3n%20e-CF.';

export default function BlogCTA() {
  const { theme } = useTheme();
  const isLight = theme === 'light';

  return (
    <section
      className="py-16 px-4 sm:px-6"
      style={{
        background: isLight
          ? 'linear-gradient(135deg, #f0fdff 0%, #ecfdf5 100%)'
          : 'linear-gradient(135deg, #0a1628 0%, #0d2a1e 100%)',
      }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <div
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase mb-5 font-body"
          style={{ backgroundColor: '#00cfff15', color: '#00cfff', border: '1px solid #00cfff30' }}
        >
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-question-line text-xs" />
          </div>
          ¿Tienes dudas?
        </div>

        <h2 className={`font-heading text-3xl sm:text-4xl font-extrabold mb-4 ${isLight ? 'text-navy-950' : 'text-white'}`}>
          ¿Listo para implementar el{' '}
          <span className="text-electric">e-CF en tu negocio?</span>
        </h2>

        <p className={`font-body text-base leading-relaxed mb-8 max-w-xl mx-auto ${isLight ? 'text-navy-600' : 'text-white/55'}`}>
          Nuestro equipo responde en minutos. Cuéntanos sobre tu negocio y te
          explicamos exactamente qué necesitas para cumplir con la DGII sin
          complicaciones.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1eba57] text-white text-sm font-extrabold px-7 py-3.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap font-body"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </div>
            Consultar por WhatsApp
          </a>
          <a
            href="/#book-demo"
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-electric to-emerald-400 text-navy-950 text-sm font-extrabold px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap font-body ring-2 ring-electric/30 hover:ring-electric/60"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-schedule-line text-sm" />
            </div>
            Agenda una Demo Gratis
          </a>
        </div>

        <p className={`font-body text-xs mt-5 ${isLight ? 'text-slate-400' : 'text-white/30'}`}>
          Sin compromiso · Certificación e-CF en 3–5 días hábiles · Pago único desde $300
        </p>
      </div>
    </section>
  );
}
